let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dzq38")).then(() => parcelRequire('esTLZ'));